import {useParams, usePathname, useSearchParams} from 'next/navigation'
import {useRouter} from 'next/router'
import type {FieldValues} from 'react-hook-form'

export const appendCurrentParams = (params: URLSearchParams, currentParams: URLSearchParams) => {
  currentParams.forEach((value, key) => {
    if (!params.has(key)) {
      params.append(key, value)
    }
  })

  return params
}

export const useGetPricingFormHandler = ({successUrl}: {successUrl?: string}) => {
  const params = new URLSearchParams()
  const currentParams = useSearchParams()
  const originPage = useGetOriginPageParam()

  const pricingFormHandler = (data: FieldValues) => {
    for (const key in data) {
      if (data[key]) {
        for (const value of data[key]) {
          params.append(value.replace(/ /g, '').toLowerCase(), 'true')
        }
      }
    }

    appendCurrentParams(params, currentParams)

    params.append('origin-page', originPage)
    params.append('element', 'pricing-menu')
    params.append('intent', 'pricing')

    return (location.href = `${successUrl}?${params.toString()}`)
  }

  return {pricingFormHandler}
}

export const useGetOriginPageParam = (): string => {
  const {locale} = useRouter()
  const {uid, subpageUid} = useParams() || {}
  const pathname = usePathname()

  // If we have dynamic params (from routes like /[uid] or /[uid]/[subpageUid]), use them
  if (uid) {
    const originPage = [locale, uid, subpageUid].filter(Boolean).join('/')
    return originPage
  }

  // Otherwise, fallback to pathname (for hardcoded routes like /stresstimonials)
  // Remove leading slash and extract path segments
  const pathWithoutSlash = pathname?.replace(/^\//, '') || ''
  const segments = pathWithoutSlash.split('/').filter(Boolean)

  // If first segment is a locale (e.g., 'en-us'), remove it since we add locale separately
  if (segments[0] && segments[0].match(/^[a-z]{2}-[a-z]{2}$/)) {
    segments.shift()
  }

  const originPage = [locale, ...segments].filter(Boolean).join('/')
  return originPage
}
